<template>
  <div class="main-content">
    <HeadContent
      :title="roleManageTit"
      routename="configIndex"
      :subtitle-first="headTit"
      :subtitle-second="roleManageTit"
    />
    <!-- <div class="height-space-div" /> -->
    <template v-for="(item, index) in roleList">
      <role-item
        :key="item.id"
        :data="item"
        :index="index"
        @manage="handleManage"
        @change="onChange"
      />
    </template>
    <div
      v-show="initLoading"
      class="castom_role clearfix"
    >
      <span class="castom_title">{{ $t('message["1661"]') }}</span>
      <div class="custom_btn">
        <a-button
          :disabled="disabledCustomBtn"
          @click="toAdd"
        >
          <i class="iconfont iconicon-test10" />
          {{ $t('message["1349"]') }}
        </a-button>
        <a-tooltip
          placement="top"
          overlay-class-name="prompt-tooltip2"
        >
          <template slot="title">
            {{ $t('message["567"]') }}
          </template>
          <i
            class="iconfont iconicon-test32 fs-gray explain-btn"
          />
        </a-tooltip>
      </div>
    </div>
    <template v-for="(item, index) in customRoleList">
      <role-item
        :key="item.id"
        :data="item"
        :index="index"
        @manage="handleCustomManage"
        @change="onChange2"
      />
    </template>
    <a-spin
      v-if="loadingContent"
      class="spin-styl"
    />
    <role-manage-drawer
      :role-info="roleDetail"
      :edit-type="editType"
    />
    <!-- <add-role-manage-drawer
      :role-info="roleDetail"
    /> -->
  </div>
</template>
<script>
import { mapActions, mapState, mapMutations } from 'vuex'
import RoleManageDrawer from './RoleManageDrawer'
import HeadContent from '@/components/pc/HeadContent'
import RoleItem from './components/RoleItem'
import AddRoleManageDrawer from './AddRoleManageDrawer'
export default {
  components: {
    RoleManageDrawer,
    HeadContent,
    RoleItem,
    AddRoleManageDrawer
  },
  data () {
    return {
      roleList: [],
      roleDetail: {},
      customRoleList: [], // 自定义角色
      editType: 'systemRoleEdit'
    }
  },
  computed: {
    ...mapState('role', ['roleDataList', 'addRoleDrawerVisible', 'initLoading', 'roleDrawerVisible', 'loadingContent']),
    disabledCustomBtn () {
      return this.customRoleList.length >= 1
    },
    baseinfo () {
      return this.$store.state.baseinfo
    },
    roleManageTit () {
      return this.$t('message["505"]')
    },
    headTit () {
      return this.$t('message["1326"]')
    }
  },
  watch: {
    roleDataList: {
      handler (val) {
        if (!val) return
        this.roleList = val.filter(item => item.roleid !== item.system_role)
        this.customRoleList = val.filter(item => item.roleid === item.system_role)
        // document.title = `角色管理-${this.baseinfo.projectname}-${this.baseinfo.comname}`
      },
      immediate: true
    }
  },
  async mounted () {
    const chain = await this.fetchGetRoleDatas()
    chain.onSuccess(raw => {
      // const { projectname = '', comname = '' } = this.baseinfo
      document.title = this.$t('message["505"]') + `-${this.baseinfo.projectname}-${this.baseinfo.comname}`
    })
      .fetch()
  },
  methods: {
    ...mapActions('role', ['fetchGetRoleDatas', 'changeRoleManageVisible', 'fetchGetPermissionDatas', 'fetchChangeRoleStatus']),
    ...mapMutations('role', ['SET_ADD_ROLE_VISIBLE']),
    onChange (result) {
      const { item, index } = result
      item.status = 0
      this.fetchChangeRoleStatus({ roleid: item.roleid })
      this.$set(this.roleList, index, item)
    },
    onChange2 (result) {
      const { item, index } = result
      item.status = 0
      this.fetchChangeRoleStatus({ roleid: item.roleid })
      this.$set(this.customRoleList, index, item)
    },
    handleManage (value) {
      this.editType = 'systemRoleEdit'
      this.ManangeDrawer(value, this.editType)
    },
    handleCustomManage (value) {
      this.editType = 'defineRoleEdit'
      this.ManangeDrawer(value, this.editType)
    },
    ManangeDrawer (value, type) {
      this.roleDetail = value
      const params = type !== 'addRole' ? { roleid: value.roleid } : {}
      this.fetchGetPermissionDatas(params)
      this.changeRoleManageVisible(true)
    },
    toAdd () {
      this.editType = 'addRole'
      if (this.disabledCustomBtn) return
      this.ManangeDrawer({}, this.editType)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/css/statistic/style.scss';
.height-space-div {
  height: 16px;
}
.spin-styl {
  position: absolute;
  top: 50%;
  left: 50%;
}
.castom_role {
  width: 100%;
  height: 64px;
  margin-top: 40px;
  border-top: 1px solid #EBEBEB;
  padding-top: 8px;
  overflow: hidden;
  .castom_title {
    float: left;
    font-size: 18px;
    color: #808080;
    line-height: 32px;
  }
  .custom_btn {
    float: right;
    margin-right: 12px;
    .iconicon-test10 {
      color: #ccc;
      font-size: 4px;
      font-weight: 600;
      margin-right: 4px;
    }
  }
}
</style>
<style lang="scss">
.prompt-tooltip2 {
  min-width: 200px;
  max-width: 400px;
  .ant-tooltip-inner {
    color: $gray3;
    min-width: 200px;
    max-width: 400px;
  }
  .ant-tooltip-content:after {
    content: "";
    position: absolute;
    width: 0;
    height: 0;
    left: 50%;
    margin-left: -7px;
    border-width: 7px 7px 0px 7px;
    border-color: transparent;
    border-top-color: #ebebeb;
    border-style: solid;
  }
  &.ant-tooltip-placement-top {
    .ant-tooltip-arrow {
      bottom: -4px !important;
      z-index: 2;
      border-top-color: #fff !important;
    }
  }
}
</style>
